import React from 'react'
import { Text, CardContainer, Icon, LabelValue } from '../../elementals'
import { ListingWireInstruction } from '@adc/sdk/types'
import classnames from 'classnames/bind'
import { ColorNames } from '../../../constants'
import styles from './styles.scss'
import {
  AutomationTarget,
  CardContainerProps,
  SlottableComponent,
} from '../../..'
const cx = classnames.bind(styles)

interface WireInstructionFieldsProps extends AutomationTarget {
  label: string
  value: React.ReactNode
  level?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8
}

export const WireInstructionField = ({
  label,
  value,
  elmId,
  level,
}: WireInstructionFieldsProps) => (
  <>
    <div className={cx('field-container')}>
      <LabelValue
        label={label}
        value={value}
        elmId={
          elmId || `wire_instruction_${label.toLowerCase().replace(/ /g, '_')}`
        }
        level={level || 3}
      />
    </div>
    <hr className={cx('line-separator')} />
  </>
)

interface WireInstructionsProps
  extends SlottableComponent<'header' | 'before' | 'after'> {
  wireInstruction: ListingWireInstruction
  showTitle?: boolean
  cardContainerProps?: CardContainerProps
}

const WireInstructions = (props: WireInstructionsProps) => {
  const {
    slots,
    wireInstruction,
    showTitle = true,
    cardContainerProps = {},
  } = props

  return (
    <CardContainer
      elmId='wire_instructions_container'
      borderRadius='medium'
      padding='medium'
      dropShadow='medium'
      backgroundColor={ColorNames.White}
      {...cardContainerProps}
    >
      {showTitle && (
        <div className={cx('title-wrapper')}>
          <Icon
            iconStyle='regular'
            name='bank'
            size='big'
            color={ColorNames.Info}
            className={cx('u-mr-2')}
          />

          <Text size='huge' weight='heavy'>
            Wiring Instructions
          </Text>
        </div>
      )}
      {slots?.header?.()}
      <CardContainer
        className={cx('wire-instructions')}
        elmId='wire_instructions'
        borderRadius='small'
        padding='small'
        backgroundColor={ColorNames.OffWhite}
      >
        {slots?.before?.()}
        <WireInstructionField
          label='Bank Name'
          value={wireInstruction.bank_name}
          elmId='wire_instructions_bank_name'
        />
        <WireInstructionField
          label='ABA/Routing #'
          value={wireInstruction.routing_number}
          elmId='wire_instructions_routing_number'
        />
        <WireInstructionField
          label='Account Name'
          value={wireInstruction.account_name}
          elmId='wire_instructions_account_name'
        />
        <WireInstructionField
          label='Account Number'
          value={wireInstruction.account_number}
          elmId='wire_instructions_account_number'
        />
        <WireInstructionField
          label='Bank Address'
          value={`${wireInstruction.street_description}, ${wireInstruction.municipality}, ${wireInstruction.country_primary_subdivision} ${wireInstruction.postal_code}`}
          elmId='wire_instructions_bank_address'
        />
        {slots?.after?.()}
      </CardContainer>
    </CardContainer>
  )
}

export default WireInstructions
